/**
 * Code generated by scripts/gen-phosphor-icons.mjs. DO NOT EDIT.
 * Phosphor Icons 2.1.1, MIT License. See NOTICE.md.
 */

import {createSinglePathSVG} from './TEMPLATE'

// Phosphor: calendar-dots (regular)
export const CalendarClock_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 256 256',
  path: 'M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-68-76a12,12,0,1,1-12-12A12,12,0,0,1,140,132Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,132ZM96,172a12,12,0,1,1-12-12A12,12,0,0,1,96,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,172Z',
})
